import type {MaskitoMaskExpression} from '@maskito/core';

/**
 * Источник - https://github.com/taiga-family/maskito/blob/main/projects/phone/src/lib/masks/phone/utils/generate-phone-mask.ts
 */
export function generatePhoneMask({
    value,
    template,
    prefix,
}: {
    value: string;
    template: string;
    prefix: string;
}): MaskitoMaskExpression {
    return [
        ...prefix,
        ...(template ? template.
            slice(prefix.length).
            split('').
            map((char) =>
                (char === 'x' || (/\d/).test(char) ? /\d/ : char),
            ) : new Array(Math.max(value.length - prefix.length, prefix.length)).fill(
            /\d/,
        )),
    ];
}
